import React from 'react'
import {
  array,
  func,
  string,
  number,
  oneOfType,
  node,
  object,
} from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import Section from '@/components/Product/Section'

import Item from './Item'

const wrapperCss = css`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin-top: -2px;

  ${mediaQueries.mediumScreen()} {
    margin-top: 0px;
    padding-top: 8px;
  }
`

const TextSection = ({ items = [], innerRef, id, title, cols, color }) => (
  <Section id={id} title={title} ref={innerRef}>
    <div css={wrapperCss}>
      {items.map((item, index) => (
        <Item
          key={`${title}-${index}`}
          title={item.title}
          description={item.description}
          cols={cols}
          color={color}
        />
      ))}
    </div>
  </Section>
)

TextSection.propTypes = {
  items: array,
  innerRef: func,
  id: string,
  title: oneOfType([string, func, node, object]),
  cols: number,
  color: string,
}

export default React.forwardRef((props, ref) => (
  <TextSection innerRef={ref} {...props} />
))
